module.exports = __webpack_public_path__ + "files/720289eff91689f0383bd387a1aab6d7.png";